// manage left corner notif popup
/**
 * manage sub elements of bottom left corner popup
 * @param {boolean} show whether to show or hide popup
 * @param {number} timer how long to show (0 is forever) (in sec) (undefined is ok)
 * @param {number} pic which pic to show (undefined is ok)
 * @param {string} text what text to show (keep short) (undefined is ok)
 * @param {string} color what color group to set popup (blue, green, or gold (default)) (undefined is ok)
 */
export async function manageCornerPopup(showCornPop = true, timer = 0, pic = undefined, text, color = undefined) {
    let cornPop = document.querySelector(`[cornPopDiv]`);

    // check if cornpop exists
    if (!cornPop) { return true }

    // set picture    
    let cornPopPic = cornPop.querySelector(`[cornPopPicDiv]`);
    if ((pic != undefined) && (typeof pic === "number")) { // don't hide pic div
        // hide all direct children
        [...cornPopPic.children].forEach(child => child.style.display = 'none');

        // show particular pic
        if (pic == 1) {
            cornPopPic.querySelector(`[cornPopPic1]`).style.display = `flex`;
        }

        // show pic div
        cornPopPic.style.display = `flex`;
    } else {
        // hide pic div
        cornPopPic.style.display = `none`;
    }

    // set text
    let cornPopText = cornPop.querySelector(`[cornPopTxtDiv]`);
    if ((text != undefined) && (typeof text === "string")) {
        // hide all direct children
        [...cornPopText.children].forEach(child => child.style.display = 'none');

        // set text
        cornPopText.querySelector(`[cornPopTxtStr]`).textContent = text;
        cornPopText.querySelector(`[cornPopTxtStr]`).style.display = `block`;

        // show text div
        cornPopText.style.display = `flex`;
    } else {
        // hide text div
        cornPopText.style.display = `none`;
    }

    // show popup
    if (showCornPop) { // show
        // pick a color
        let backColor;
        let bordColor;
        let textColor;
        if (color == `blue`) {
            backColor = `rgba(20, 25, 252, 0.2)`;
            bordColor = `#1419fc`;
            textColor = `black`;
        }
        else if (color == `green`) {
            backColor = `rgba(37, 175, 37, 0.25)`;
            bordColor = `#25af25`;
            textColor = `black`;
        }
        else { // default: gold
            backColor = `rgba(255, 190, 8, 0.25)`;
            bordColor = `#ffbe08`;
            textColor = `black`;
        }

        // get bubble
        let bubble = cornPop.querySelector(`[bubble]`);

        // set background, border, and text colors
        bubble.style.backgroundColor = backColor;
        bubble.style.borderColor = bordColor;
        bubble.style.color = textColor;

        // show
        cornPop.style.display = `flex`;
    } else { // hide
        cornPop.style.display = `none`;
    }

    // timer
    if ((timer != undefined) && (timer != 0) && (typeof timer === "number")) {
        setTimeout(() => {
            cornPop.style.display = 'none';
        }, timer * 1000);
    }

    return true;
}

// manage error popup
/**
 * manages visualization of fullscreen error popup
 * @param {boolean} showPop whether to show popup
 * @param {boolean} showX whether to show clickable x (undefined ok)
 * @param {boolean} showButton whether to show action button (undefined ok)
 * @param {number} timer how long to show popup (0/undef is forever) (undefined ok)
 * @param {number} pic which picture to show: 1=triangle warn (undefined ok)
 * @param {string} message error subtext, (undefined ok) (empty has default str)
 * @param {string} button button text (undefined ok) (empty has default str)
 * @param {string} buttonLink url to redirect (undefined ok) (empty has default reload pg)
 * @param {Object} elements error elements object in pageElements (undefined ok)
 */
export async function manageErrorPopup(showPop = true, showX = false, showButton = true, timer = 0, pic = undefined, message = ``, button = ``, buttonLink = ``, elements = undefined) {
    console.log(`params:`, showPop, showX, showButton, timer, pic, message, button, buttonLink, elements);

    // backup elements
    if (!elements) {
        elements = {
            div: document.querySelector(`[popErrDiv]`),
            bubble: {
                div: document.querySelector(`[popErrBDiv]`),
                exit: document.querySelector(`[popErrBExt]`),
                icon: {
                    div: document.querySelector(`[popErrBIcnDiv]`),
                    pic: document.querySelector(`[popErrBIcnPic]`),
                },
                title: {
                    div: document.querySelector(`[popErrBTitDiv]`),
                    text: document.querySelector(`[popErrBTitTxt]`),
                },
                message: {
                    div: document.querySelector(`[popErrBMsgDiv]`),
                    text: document.querySelector(`[popErrBMsgTxt]`),
                },
                bottom: {
                    div: document.querySelector(`[popErrBBotDiv]`),
                    button: {
                        div: document.querySelector(`[popErrBBotButDiv]`),
                        text: document.querySelector(`[popErrBBotButTxt]`),
                    },
                },
            },
        };
    }

    // check if popup exists
    if (!elements?.div) return false;

    // set pic (always show)
    if (elements?.bubble?.icon?.div && elements?.bubble?.icon?.pic) {
        // set icon
        let icons = {
            // warning triangle - default icon
            1: `<svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-alert-triangle-popup">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <path d="M12 9v4" />
                    <path d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z" />
                    <path d="M12 16h.01" />
                </svg>`,

            // example
            2: undefined,
        };

        // set icon
        elements.bubble.icon.pic.innerHTML = pic && icons[pic] ? icons[pic] : icons[1];

        // icon color
        elements.bubble.icon.pic.style.color = `#dc2528`;

        // show pic div
        elements.bubble.icon.pic.style.display = `flex`;
        elements.bubble.icon.div.style.display = `flex`;
    }

    // set title (always show)
    if (elements?.bubble?.title?.div && elements?.bubble?.title?.text) {
        // set title
        elements.bubble.title.text.textContent = `Error`;

        // show
        elements.bubble.title.div.style.display = `flex`;
        elements.bubble.title.text.style.display = `flex`;
    }

    // set message (always show)
    if (elements?.bubble?.message?.div && elements?.bubble?.message?.text) {
        // set msg
        elements.bubble.message.text.textContent = message ? message : `Oh no! Something went wrong. If this continues, please let us know.`;

        // show
        elements.bubble.message.div.style.display = `flex`;
        elements.bubble.message.text.style.display = `block`;
    }

    // set button
    if (elements?.bubble?.bottom?.button?.div && elements?.bubble?.bottom?.button?.text && elements?.bubble?.bottom?.div) {
        // show or hide
        if (showButton) {
            // set button text
            elements.bubble.bottom.button.text.textContent = button ? button : `Okay`;

            // click
            elements.bubble.bottom.button.div.onclick = function(event) {
                // stop default
                event.preventDefault();

                console.log(`clicked`);

                // redirect
                window.location.href = buttonLink ? buttonLink : window.location.href;
            };

            // show
            elements.bubble.bottom.button.text.style.display = `flex`;
            elements.bubble.bottom.button.div.style.display = `flex`;
            elements.bubble.bottom.div.style.display = `flex`;
        } else {
            // hide
            elements.bubble.bottom.button.text.style.display = `none`;
            elements.bubble.bottom.button.div.style.display = `none`;
            elements.bubble.bottom.div.style.display = `none`;
        }
    }

    // set exit button 
    if (elements?.bubble?.exit) {
        // show or hide
        if (showX) {
            // click
            elements.bubble.exit.onclick = function(event) {
                // stop default
                event.preventDefault();

                // hide popup
                elements.div.style.display = `none`;
            };

            // show
            elements.bubble.exit.style.display = `flex`;
        } else {
            // hide
            elements.bubble.exit.style.display = `none`;
        }
    }

    // overall popup
    if (showPop) { // show
        elements.div.style.display = `flex`;
    } else { // hide
        elements.div.style.display = `none`;
    }

    // set timer
    if (timer && timer > 0 && (typeof timer === "number")) {
        setTimeout(() => {
            elements.div.style.display = 'none';
        }, timer * 1000);
    }

    return true;
}

// create a hover help popup
/**
 * create a hover help popup
 * @param {DOM element} sourceElement element to attach to
 * @param {string} text popup string
 * @param {string} position place popup above, below, right, left (or auto) of element
 * @returns 
 */
export function attachHelpText(sourceElement, text, position) {
    try {
        if (sourceElement) {
            // When the user mouses over the sourceElement, set a timer then create and position for the popup.
            sourceElement.addEventListener('mouseover', function (e) {
                // Clear any existing timer to avoid multiple triggers.
                if (sourceElement._helpTimer) {
                    clearTimeout(sourceElement._helpTimer);
                }
            
                // Set a timer of 200ms before showing the popup.
                sourceElement._helpTimer = setTimeout(function () {

                    // Create the help text div and assign the required CSS class.
                    var helpDiv = document.createElement('div');
                    helpDiv.className = 'help-text';
                    helpDiv.innerText = text;
                    // Use absolute positioning so that we can place it anywhere.
                    helpDiv.style.position = 'absolute';
                    // Hide it initially so we can measure it without any flicker.
                    helpDiv.style.visibility = 'hidden';
                    document.body.appendChild(helpDiv);
            
                    // Get the bounding rectangle of the source element.
                    var sourceRect = sourceElement.getBoundingClientRect();
                    // After appending the helpDiv, we can measure its dimensions.
                    var helpWidth = helpDiv.offsetWidth;
                    var helpHeight = helpDiv.offsetHeight;
            
                    // A gap between the sourceElement and help text.
                    var GAP = 10;
            
                    /*
                    Given a placement ("right", "left", "above", "below"),
                    return an object with calculated { left, top } values.
                    */
                    function getCoordinates(placement) {
                        var coords = { left: 0, top: 0 };
                        if (placement === 'right') {
                            coords.left = sourceRect.right + GAP;
                            // Vertically center the popup relative to the source.
                            coords.top = sourceRect.top + (sourceRect.height - helpHeight) / 2;
                        } else if (placement === 'left') {
                            coords.left = sourceRect.left - helpWidth - GAP;
                            coords.top = sourceRect.top + (sourceRect.height - helpHeight) / 2;
                        } else if (placement === 'above') {
                            coords.top = sourceRect.top - helpHeight - GAP;
                            // Horizontally center the popup relative to the source.
                            coords.left = sourceRect.left + (sourceRect.width - helpWidth) / 2;
                        } else if (placement === 'below') {
                            coords.top = sourceRect.bottom + GAP;
                            coords.left = sourceRect.left + (sourceRect.width - helpWidth) / 2;
                        }
                        return coords;
                    }
        
                    /*
                    Checks if the helpDiv placed at the given coordinates
                    would be off-screen.
                    */
                    function isOffScreen(coords) {
                        // Note: getBoundingClientRect() gives values relative to the viewport.
                        var left = coords.left;
                        var top = coords.top;
                        var viewportWidth = document.documentElement.clientWidth;
                        var viewportHeight = document.documentElement.clientHeight;
                
                        if (left < 0 ||
                            top < 0 ||
                            (left + helpWidth) > viewportWidth ||
                            (top + helpHeight) > viewportHeight) {
                            return true;
                        }
                        return false;
                    }
        
                    // Determine which placement(s) to try.
                    var placementsToTry = [];
                    if (position === 'auto') {
                        // Try these in order.
                        placementsToTry = ['above', 'below', 'right', 'left'];
                    } else {
                        placementsToTry = [position];
                    }
            
                    // Try each placement until one fits on screen.
                    var finalCoords = null;
                    for (var i = 0; i < placementsToTry.length; i++) {
                        var coords = getCoordinates(placementsToTry[i]);
                        if (!isOffScreen(coords)) {
                            finalCoords = coords;
                            break;
                        }
                    }
            
                    // If none of the placements fit completely on-screen, use the coordinates from the last tried placement.
                    if (!finalCoords) {
                        finalCoords = getCoordinates(placementsToTry[placementsToTry.length - 1]);
                    }
            
                    // Optionally, clamp the coordinates so that the popup is not off-screen.
                    function clamp(val, min, max) {
                        return Math.min(Math.max(val, min), max);
                    }

                    var viewportWidth = document.documentElement.clientWidth;
                    var viewportHeight = document.documentElement.clientHeight;
                    
                    // Clamp using current coordinates (which are relative to the viewport).
                    finalCoords.left = clamp(finalCoords.left, 0, viewportWidth - helpWidth);
                    finalCoords.top = clamp(finalCoords.top, 0, viewportHeight - helpHeight);
            
                    // Set the final position.
                    helpDiv.style.left = finalCoords.left + window.scrollX + "px";
                    helpDiv.style.top = finalCoords.top + window.scrollY + "px";
                    helpDiv.style.visibility = 'visible';
            
                    // Save a reference to the helpDiv so we can remove it later.
                    sourceElement._helpDiv = helpDiv;

                    // Create a MutationObserver to monitor removal of the sourceElement.
                    var observer = new MutationObserver(function(mutationsList, observer) {
                        // If the sourceElement is no longer in the document, remove the help text.
                        if (!document.body.contains(sourceElement)) {
                            if (sourceElement._helpDiv) {
                                document.body.removeChild(sourceElement._helpDiv);
                                sourceElement._helpDiv = null;
                            }
                            observer.disconnect();
                        }
                    });
                    observer.observe(document.body, { childList: true, subtree: true });
                    sourceElement._helpObserver = observer;
            
                    // Clear the timer reference since the popup has now been shown.
                    sourceElement._helpTimer = null;
                }, 200); // 200ms delay before showing the help text
            });
        
            // When the mouse leaves the sourceElement, remove the help text.
            sourceElement.addEventListener('mouseout', function (e) {
                if (sourceElement._helpTimer) {
                    clearTimeout(sourceElement._helpTimer);
                    sourceElement._helpTimer = null;
                }
                if (sourceElement._helpObserver) {
                    sourceElement._helpObserver.disconnect();
                    sourceElement._helpObserver = null;
                }
                if (sourceElement._helpDiv) {
                    document.body.removeChild(sourceElement._helpDiv);
                    sourceElement._helpDiv = null;
                }
            });
    
            return true;
        } else {
            return false;
        }
    } catch (err) {
        console.error("Error attaching help text:", err);
        return false;
    }
}

// attach help text to many canvas elements
/**
 * attach help text to many canvas elements
 * @param {object} elements nested object of DOM elements
 * @param {object} helpText mirrored nested object of strings
 */
export function processElementTreeWithHelp(elements, helpText) {
    // Recursive helper function to traverse the objects.
    function traverseCanvasObjs(elementsNode, helpTextNode) {
        // Iterate over all keys in the current object.
        for (let key in elementsNode) {
            if (elementsNode.hasOwnProperty(key)) {
                const elementValue = elementsNode[key];
                console.log('elementValue is', elementValue);
                const helpValue = helpTextNode[key];
                console.log('helpValue is', helpValue);
                // Check if the current element is an object (and not an array or null).
                if (typeof elementValue === 'object' && elementValue !== null && !Array.isArray(elementValue) && !(elementValue instanceof HTMLElement)) {
                    // If it is, continue traversing recursively.
                    traverseCanvasObjs(elementValue, helpValue);
                } else {
                    // check if array of DOM elements
                    if (elementValue !== null && Array.isArray(elementValue)) {
                        // do nothing
                    }

                    // We are at a leaf node.
                    // Check that the corresponding helpText value is an array of exactly 2 items.
                    else if (Array.isArray(helpValue) && helpValue.length === 2) {
                        attachHelpText(elementValue, helpValue[0], helpValue[1]);
                    }
                }
            }
        } 
    }
    
    // Start the recursive traversal from the top of the objects.
    traverseCanvasObjs(elements, helpText);
}